import styled from "@emotion/styled";

const ArticleDivider = styled.div`
    background: rgba(112, 112, 112, 0.05);
    height: 3px;
`;

export default ArticleDivider;
